import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import { primaryFIxed } from "../../ui-elements/button";
import InteractiveStarRating from "./InteractiveStarRating";
import { setFeedback, setFeedbackForPartner } from "../../axios/api/OrderApi";
import { useDispatch } from "react-redux";
import {
  changePopUpStatus,
  setRequestStatus,
} from "../../redux/slices/popUp/popUpSlice";

ReactModal.setAppElement("#root");

const OrderModal = ({ isOpen, onClose, orderNumber, payment }) => {
  const { t } = useTranslation();
  const [textValue, setTextValue] = useState("");
  const [rating, setRating] = useState(0);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const data = { textValue, rating, orderNumber };
    let res = await setFeedback(data);
    if (payment?.partner_status === "finished") {
      res = await setFeedbackForPartner(data);
    }
    if (res?.data) {
      dispatch(changePopUpStatus(true));
      dispatch(setRequestStatus(res.data));
    }
    onClose();
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="h-full inset-0 flex items-center justify-center lg:p-4 bg-transparent outline-none focus:outline-none border-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-75 z-50 p-[15px] md:px-0"
      bodyOpenClassName="modal-open"
    >
      <div className="relative bg-white dark:bg-[#111] sm:pt-0 shadow-lg w-full lg:max-w-2xl p-6 lg:p-8 sm:h-auto lg:relative rounded-3xl">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 sm:top-auto md:pt-3 lg:pt-0 lg:top-4 text-3xl text-[#000] dark:text-white"
        >
          &times;
        </button>
        <div className="flex flex-col items-center text-center gap-2  mb-4 sm:mb-0 sm:mt-2 md:mt-0 md:p-8 lg:p-0 lg:mb-4 pb-4">
          <h2 className="font-[500] text-[24px] md:text-[30px] text-secondary_black dark:text-white">
            {payment?.partner_status === "finished"
              ? t("valueFeedback") + "" + t(payment.partnerName)
              : t("weValueYourFeedback")}
          </h2>
          <span className="text-[18px] text-[#323232] dark:text-[#9a9a9a]">
            {payment?.partner_status === "finished"
              ? t(payment.service)
              : t("hopeToServeYou")}
          </span>
          {payment?.partner_status === "finished" && (
            <span className="text-[18px] text-[#323232] dark:text-[#9a9a9a] text-center ">
              {payment.start_date}
            </span>
          )}
          <span className="f pt-4">
            <InteractiveStarRating count={rating} onRatingChange={setRating} />
          </span>
        </div>
        <div className="flex flex-col items-center gap-9 sm:gap-4 lg:gap-9">
          <textarea
            className="w-full bg-[#dadada] dark:bg-secondary_black rounded-[7px] shadow-md overflow-hidden px-4 py-3 ring-2 ring-gray-200 dark:ring-[#3a3a3a] hover:ring-primary dark:hover:ring-primary transition-all duration-300 prose-t16_regular focus:outline-none focus:ring-2 focus:ring-primary dark:focus:ring-primary resize-none mt-2"
            value={textValue}
            rows={6}
            placeholder={t("additionalInformation")}
            onChange={(e) => setTextValue(e.target.value)}
          />
          <button onClick={handleSubmit} className={primaryFIxed}>
            {t("submit2")}
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default OrderModal;
